import { iconFactory } from '../iconFactory'

export const Point = iconFactory(
  'Point',
  ({ fill }) => (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99992 13.333C10.9454 13.333 13.3333 10.9452 13.3333 7.99967C13.3333 5.05416 10.9454 2.66634 7.99992 2.66634C5.0544 2.66634 2.66659 5.05416 2.66659 7.99967C2.66659 10.9452 5.0544 13.333 7.99992 13.333ZM7.99992 14.6663C11.6818 14.6663 14.6666 11.6816 14.6666 7.99967C14.6666 4.31778 11.6818 1.33301 7.99992 1.33301C4.31802 1.33301 1.33325 4.31778 1.33325 7.99967C1.33325 11.6816 4.31802 14.6663 7.99992 14.6663Z"
        fill={fill}
      />
      <path
        d="M5.93335 11.5363H7.01602V9.06699H8.05202C9.54535 9.06699 10.6374 8.36966 10.6374 6.86699C10.6374 5.31766 9.54535 4.66699 8.01468 4.66699H5.93335V11.5363ZM7.01602 8.06433V5.73366H7.91202C9.00402 5.73366 9.57335 5.96166 9.57335 6.86699C9.57335 7.77233 9.05068 8.06433 7.94935 8.06433H7.01602Z"
        fill={fill}
      />
    </>
  ),
  { viewBox: '0 0 16 16', height: '16px', width: '16px' },
)
